export default function focusFirstEmptyInput(form: HTMLFormElement) {
  const inputs = Array.from(
    form.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
      'input[type="text"]:not([disabled]), input[type="email"]:not([disabled]), input[type="password"]:not([disabled]), textarea:not([disabled])'
    )
  );

  for (const input of inputs) {
    if (!input.value.trim()) {
      input.focus();
      break;
    }
  }
};
